export default __webpack_public_path__ + "static/media/light1.0b4abe2a.svg";